import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const links = [
  { label: "What We Do", target: "#services" },
  { label: "Process", target: "#how" },
  { label: "About", target: "#about" },
];

export const Nav = () => (
  <header
    data-testid="site-header"
    className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#0B0A09]/90 backdrop-blur-xl"
  >
    <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-8 lg:px-16">
      <button
        data-testid="nav-logo-button"
        onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
        className="cursor-pointer"
        aria-label="Back to top"
      >
        <Logo />
      </button>
      <nav className="hidden items-center gap-10 md:flex" data-testid="nav-links">
        {links.map((l) => (
          <button
            key={l.target}
            data-testid={`nav-link-${l.label.toLowerCase()}`}
            onClick={() => scrollToId(l.target)}
            className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400 transition-colors duration-300 hover:text-ruby"
          >
            {l.label}
          </button>
        ))}
      </nav>
      <button
        data-testid="nav-enquire-button"
        onClick={() => scrollToId("#enquire")}
        className="btn-magnetic rounded-full bg-gradient-to-r from-[#E5484D] to-[#C8102E] px-6 py-2.5 font-heading text-sm font-semibold text-white"
      >
        Enquire Now
      </button>
    </div>
  </header>
);
